module.exports = "/packs/images/cruk_new~c1ce2e1035c7e7055a87d13ec1b2d6ee.png";